import React from "react";
import ToggleIcon from "../../../../common/ToggleIcon";

export default class InputMethodProductCatalog extends ToggleIcon {
    render() {
        return (<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M24 16.5C24 14.9087 24.6321 13.3826 25.7574 12.2574C26.8826 11.1321 28.4087 10.5 30 10.5H42C42.3978 10.5 42.7794 10.658 43.0607 10.9393C43.342 11.2206 43.5 11.6022 43.5 12V36C43.5 36.3978 43.342 36.7794 43.0607 37.0607C42.7794 37.342 42.3978 37.5 42 37.5H30C28.4087 37.5 26.8826 38.1321 25.7574 39.2574C24.6321 40.3826 24 41.9087 24 43.5"
                    stroke={this.getColor()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path
                    d="M4.5 36C4.5 36.3978 4.65804 36.7794 4.93934 37.0607C5.22064 37.342 5.60218 37.5 6 37.5H18C19.5913 37.5 21.1174 38.1321 22.2426 39.2574C23.3679 40.3826 24 41.9087 24 43.5V16.5C24 14.9087 23.3679 13.3826 22.2426 12.2574C21.1174 11.1321 19.5913 10.5 18 10.5H6C5.60218 10.5 5.22064 10.658 4.93934 10.9393C4.65804 11.2206 4.5 11.6022 4.5 12V36Z"
                    stroke={this.getColor()} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
        )
    }
}